import UI from './ui-base';
import EventHandler from '../_dependencyvendor/event-handler';
// eslint-disable-next-line no-unused-vars
import { dataSetToObject, getIndex } from '../util/dom-util';

// eslint-disable-next-line no-unused-vars
const VERSION = '2.0.0';
const NAME = 'ui.accordionNew';

const ARIA_CONTROLS = 'aria-controls';

const dataAttrConfig = {
  active: -1,
  activeClass: 'active',
  toggle: true,
  onlyOne: false,
  animation: true,
};

const defaultConfig = {
  ...dataAttrConfig,
  stateClass: {
    expanding: 'expanding',
    expand: 'expand',
    expanded: 'expanded',
  },
};

class AccordionNew extends UI {
  constructor(element, config = {}) {
    super(element, config);
    this._setupConfog(config);
    this._animating = false;
    this._current = {
      tab: null,
      content: null,
    };
    this._before = {
      tab: null,
      content: null,
    };
  }

  static GLOBAL_CONFIG = {};

  static get EVENT() {
    return {
      OPEN: `${NAME}.open`,
      OPEND: `${NAME}.opened`,
      CLOSE: `${NAME}.close`,
      CLOSED: `${NAME}.closed`,
    };
  }

  static get NAME() {
    return NAME;
  }

  init() {
    this._initEvents();
    this._current = null;
    this._before = null;
  }

  open(target) {
    this._selectCurrent(target);
    this._open();
  }

  openAll() {
    // todo acc in acc 처리해야 함
    const headers = this._element.querySelectorAll(`[${ARIA_CONTROLS}]`);
    headers.forEach(header => {
      this.open(header);
      this._animating = false;
    });
  }

  close(target) {
    this._selectCurrent(target);
    this._close();
  }

  closeAll() {
    // todo acc in acc 처리해야 함
    const headers = this._element.querySelectorAll(`[${ARIA_CONTROLS}]`);
    headers.forEach(header => {
      this._close({
        header,
        content: this._getContent(header),
      });
      this._animating = false;
    });
  }

  destroy() {
    this._removeEvents();
  }

  _setupConfog(config) {
    this._config = {
      ...defaultConfig,
      ...AccordionNew.GLOBAL_CONFIG,
      ...config,
      ...dataSetToObject(this._element, dataAttrConfig, 'acc'),
    };
  }

  _initEvents() {
    EventHandler.on(this._element, super._eventName('click'), event => {
      if (!event.target.tagName.match(/^A$|AREA|INPUT|TEXTAREA|SELECT|BUTTON|LABEL/gim)) {
        event.preventDefault();
      }
      const { toggle, activeClass } = this._config;
      const target = event.target.closest(`[${ARIA_CONTROLS}]`);

      if (target) {
        this._current = {
          header: target,
          content: this._getContent(target),
        };

        if (toggle) {
          if (this._current.header.classList.contains(activeClass)) {
            this._close(this._current);
          } else {
            this._open();
          }
        } else {
          this._open();
        }
      }
    });
  }

  _removeEvents() {
    EventHandler.off(this._element, super._eventName('click'));
  }

  _open() {
    const { activeClass, onlyOne, animation, stateClass } = this._config;
    if (this._animating === true && animation === true) return;
    const { header, content } = this._current;

    header.classList.add(activeClass);
    this._dispatch(AccordionNew.EVENT.OPEN, {
      current: this._current,
    });

    if (animation) {
      this._animating = true;
      content.classList.add(stateClass.expanding);
      content.classList.remove(stateClass.expand);
      content.style.height = `${content.scrollHeight}px`;
      EventHandler.one(content, 'transitionend', () => {
        content.classList.remove(stateClass.expanding);
        content.classList.add(stateClass.expand);
        content.classList.add(stateClass.expanded);
        content.style.height = '';
        this._animating = false;
        this._dispatch(AccordionNew.EVENT.OPEND, {
          current: this._current,
        });
      });
    } else {
      content.classList.add(stateClass.expanded);
      content.classList.add(stateClass.expand);
      header.classList.add(activeClass);
    }

    if (onlyOne === true) {
      if (this._before.header !== this._current.header) {
        this._animating = false;
        this._close();
      }
    }

    this._before = { header, content };
    this._aria(this._current, true);
  }

  _close(target) {
    const { activeClass, animation, stateClass } = this._config;
    if (this._animating === true && animation === true) return;
    const closeTarget = !!target ? target : this._before;
    if (!closeTarget.header) return;
    const { header, content } = closeTarget;
    header.classList.remove(activeClass);
    this._dispatch(AccordionNew.EVENT.CLOSE, {
      current: closeTarget,
    });
    this._aria(closeTarget, false);
    if (animation) {
      this._animating = true;
      content.style.height = `${content.getBoundingClientRect().height}px`;

      content.heightCache = content.offsetHeight;
      content.style.height = ``;
      content.classList.add(stateClass.expanding);
      content.classList.remove(stateClass.expand);
      content.classList.remove(stateClass.expanded);
      EventHandler.one(content, 'transitionend', () => {
        content.classList.remove(stateClass.expanding);
        content.classList.add(stateClass.expand);
        this._animating = false;
        this._dispatch(AccordionNew.EVENT.CLOSED, {
          current: closeTarget,
        });
      });
      return;
    } else {
      content.classList.remove(stateClass.expanding);
      content.classList.add(stateClass.expand);
    }
  }

  _selectCurrent(target) {
    // 인덱스
    if (!isNaN(target)) {
      const accHeaders = this._element.querySelectorAll(`[${ARIA_CONTROLS}]`);
      this._current = {
        header: accHeaders[target],
        content: this._getContent(accHeaders[target]),
      };
    } else {
      // 셀렉터 스트링
      if (typeof target === 'string') {
        const header = this._element.querySelector(target);
        this._current = {
          header,
          content: this._getContent(header),
        };
      } else {
        // 엘리먼트
        const tab = target.jquery ? target[0] : target;
        this._current = {
          header: tab,
          content: this._getContent(tab),
        };
      }
    }
  }

  /**
   * 웹 접근성 aria 속성 및 tabindex 설정
   * @param {*} target
   * @param {*} isActive
   */
  _aria(target, isActive = true) {
    const { toggle } = this._config;
    const { header, content } = target;
    const isSelected = isActive ? true : false;
    const isHidden = isActive ? false : true;
    const tabIndex = isActive ? 0 : -1;
    // header.setAttribute('tabIndex', tabIndex);
    header.setAttribute('aria-expanded', isSelected);
    if (toggle === false) {
      header.setAttribute('aria-disabled', isActive);
    }
    content.setAttribute('aria-hidden', isHidden);
    content.setAttribute('tabIndex', tabIndex);
  }
  /**
   * acc header(aria-controls)에 선언 된 컨텐츠 찾아서 반환
   * @param {*} target
   * @returns
   */
  _getContent(target) {
    if (!target) super._throwError(`[${target}] not found!`);
    const contentName = target.getAttribute(ARIA_CONTROLS);
    const content = document.querySelector(`#${contentName}`);
    if (!content) {
      super._throwError(`[${contentName}] does not match any content element! `);
    }

    return content;
  }

  _dispatch(event, params) {
    EventHandler.trigger(this._element, event, params);
  }
}

export default AccordionNew;
